import { yupResolver } from '@hookform/resolvers/yup';
import React from 'react';
import { useForm } from 'react-hook-form';
import FormWrapper from '../../../Components/Form/FormWrapper';
import * as yup from 'yup';
import TextAreaField from '../../../Components/Form/components/TextAreaField';
import SubmitButton from '../../../Components/Button/SubmitButton';
import InputWrapper from '../../../Components/Form/components/InputWrapper/InputWrapper';

interface Props {
	requirementId: string;
	note?: string;
	onEdit: (note: string) => void;
}

const validationSchema = yup.object({
	note: yup.string().nullable(),
});

const RequirementNote: React.FC<Props> = ({ requirementId, note, onEdit }) => {
	const formMethods = useForm({
		resolver: yupResolver(validationSchema),
		defaultValues: {
			note,
		},
	});

	const handleSubmit = (values: any) => {
		onEdit(values.note);
	};

	return (
		<FormWrapper formMethods={formMethods}>
			<InputWrapper>
				<TextAreaField name='note' label='base.shared.note' isRequired />
			</InputWrapper>
			<div className='mt-3'>
				<SubmitButton onSubmit={handleSubmit} title='base.shared.edit' />
			</div>
		</FormWrapper>
	);
};

export default RequirementNote;
